module.exports = __webpack_public_path__ + "static/media/exempleiswrong.f9eba3d5.mp3";